import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0992da02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "row space-between" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "Back", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "Edit", -1))
const _hoisted_6 = { class: "detail" }
const _hoisted_7 = ["innerHTML"]

import { TeamStory } from "@/services/entities/teamStory";
import { useTeamStoryStore } from "@/stores/teamStory";
import { onBeforeMount, onMounted, reactive } from "vue";
import { onBeforeRouteLeave } from "vue-router";
import DOMPurify from "dompurify";
import { useTeamStore } from "@/stores/team";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailView',
  props: {
    id: {},
    template: {}
  },
  setup(__props: any) {

const teamStoryStore = useTeamStoryStore();
const teamStore = useTeamStore();

const props = __props;

const state = reactive({
    saved: false,
    story: { heading: "", body: "" } as any as TeamStory,
});

function sanitizeHtml(html: string) {
    return DOMPurify.sanitize(html, { ADD_ATTR: ["target"] });
}

onMounted(async () => {
    if (props.id) {
        if (teamStoryStore.getTeamStories.length === 0) {
            await teamStoryStore.loadTeamStory(props.template);
        }
        const result = teamStoryStore.getTeamStories.find((story) => story.id?.toLowerCase() === props.id?.toLowerCase());
        if (result) {
            state.story = result;
        }
    }
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", null, _toDisplayString(_unref(teamStore).getTeamName), 1)
      ]),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.story.tags, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "tags"
          }, [
            _createElementVNode("span", null, _toDisplayString(item), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, { to: { name: 'Home' } }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: { name: 'Edit' } }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", null, _toDisplayString(state.story.heading), 1)
      ]),
      _createElementVNode("div", {
        class: "text-editor",
        innerHTML: sanitizeHtml(state.story.body)
      }, null, 8, _hoisted_7)
    ])
  ]))
}
}

})